var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.252 5.30273C7.94355 5.30273 5.25195 7.99433 5.25195 11.3027V13.7885C5.25195 14.4029 5.79015 14.9027 6.45195 14.9027H7.05195C7.21108 14.9027 7.3637 14.8395 7.47622 14.727C7.58874 14.6145 7.65195 14.4619 7.65195 14.3027V11.2169C7.65195 11.0578 7.58874 10.9052 7.47622 10.7927C7.3637 10.6801 7.21108 10.6169 7.05195 10.6169H6.50715C6.84075 8.29493 8.83875 6.50273 11.252 6.50273C13.6652 6.50273 15.6632 8.29493 15.9968 10.6169H15.452C15.2928 10.6169 15.1402 10.6801 15.0277 10.7927C14.9152 10.9052 14.852 11.0578 14.852 11.2169V14.9027C14.852 15.5645 14.3138 16.1027 13.652 16.1027H12.452V15.5027H10.052V17.3027H13.652C14.9756 17.3027 16.052 16.2263 16.052 14.9027C16.7138 14.9027 17.252 14.4029 17.252 13.7885V11.3027C17.252 7.99433 14.5604 5.30273 11.252 5.30273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportLogo);
export default __webpack_public_path__ + "static/media/support-logo.55c8b90f1d74810427e4bd86e1833253.svg";
export { ForwardRef as ReactComponent };